/* A label/value row list used throughout the drawers — ports the sample's
   `dl()` helper. `rows` is [[label, value], ...]; value can be a plain
   string or JSX (badges, tags, etc.). */
function DefinitionList({ rows }) {
  return (
    <dl className="dl">
      {rows.map(([label, value], i) => (
        <div className="row" key={i}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}

export default DefinitionList;
